<template>
    <ecranproduction poste="cuisine" />
</template>

<script>
/* eslint-disable */
/**
 * Page /cuisine.
 *
 * Volontairement vide de logique : tout l'écran de production (appairage, canal
 * temps réel, kanban, analytique, traçabilité) vit dans un socle unique partagé
 * avec /bar. Les deux pages restent distinctes - deux routes, deux entrées de
 * menu, deux permissions - mais le code n'est écrit qu'une fois, ce qui évite
 * que les deux écrans divergent à la première correction.
 *
 * Le poste conditionne la clé du jeton en localStorage, les libellés et le
 * filtre des onglets analytiques. Voir HABILLAGE dans le socle.
 */
import ecranproduction from "@/components/views/pages/screen/ecranproduction";

export default {
    name: "cuisineindex",
    components: { ecranproduction },
};
</script>
